/* eslint-disable import/no-cycle */

import {
  AssignmentInd,
  AssuredWorkload,
  Feed,
  GpsFixed,
  Home,
  Person,
} from "@mui/icons-material";
import { HomePage } from "../pages/Home";
import { MasterUserPage } from "../pages/MasterUser";
import {
  CreateFormPage,
  EditFormPage,
  MasterFormPage,
} from "../pages/MasterForm/Pages";
import {
  CreatePreventiveMEPage,
  EditPreventiveMEPage,
  PreventiveMEPage,
} from "../pages/PreventiveME/Pages";
import { MasterRolePage } from "../pages/MasterRole";
import { MasterLocationPage } from "../pages/MasterLocation/Pages/LocationList";
import { CreateLocationPage } from "../pages/MasterLocation/Pages/CreateLocation";
import { EditLocationPage } from "../pages/MasterLocation/Pages/EditLocation";
import { Route } from "../shared/Interface/route";

export const protectedRoutes: Route[] = [
  {
    key: "router-home",
    title: "Home",
    description: "Home",
    component: HomePage,
    path: "/",
    isEnabled: true,
    appendDivider: true,
    icon: <Home />,
  },
  {
    key: "router-master-user",
    title: "Master User",
    description: "Master User",
    component: MasterUserPage,
    path: "/master-user",
    isEnabled: true,
    appendDivider: true,
    icon: <Person />,
    access: "Master User",
  },
  {
    key: "router-master-role",
    title: "Master Role",
    description: "Master Role",
    component: MasterRolePage,
    path: "/master-role",
    isEnabled: true,
    appendDivider: true,
    icon: <AssignmentInd />,
    access: "Master Role",
  },
  {
    key: "router-master-location",
    title: "Master Location",
    description: "Master Location",
    component: MasterLocationPage,
    path: "/master-location",
    isEnabled: true,
    appendDivider: true,
    icon: <GpsFixed />,
    access: "Master Location",
  },
  {
    key: "router-master-location-create",
    title: "Create Location",
    description: "Create Location",
    component: CreateLocationPage,
    path: "/master-location/create",
    isEnabled: false,
    access: "Master Location",
  },
  {
    key: "router-master-location-edit",
    title: "Edit Location",
    description: "Edit Location",
    component: EditLocationPage,
    path: "/master-location/:id",
    isEnabled: false,
    access: "Master Location",
  },
  {
    key: "router-master-form",
    title: "Master Form",
    description: "Master Form",
    component: MasterFormPage,
    path: "/master-form",
    isEnabled: true,
    appendDivider: true,
    icon: <Feed />,
    access: "Master Form",
  },
  {
    key: "router-master-form-create",
    title: "Create Form",
    description: "Create Form",
    component: CreateFormPage,
    path: "/master-form/create",
    isEnabled: false,
    access: "Master Form",
  },
  {
    key: "router-master-form-edit",
    title: "Edit Form",
    description: "Edit Form",
    component: EditFormPage,
    path: "/master-form/:id",
    isEnabled: false,
    access: "Master Form",
  },
  {
    key: "router-preventive-me",
    title: "Preventive ME",
    description: "Preventive ME",
    component: PreventiveMEPage,
    path: "/preventive-me",
    isEnabled: true,
    appendDivider: true,
    icon: <AssuredWorkload />,
    access: "Preventive ME",
  },
  {
    key: "router-preventive-me-create",
    title: "Create Preventive ME",
    description: "Create Preventive ME",
    component: CreatePreventiveMEPage,
    path: "/preventive-me/create",
    isEnabled: false,
    access: "Preventive ME",
  },
  {
    key: "router-preventive-me-edit",
    title: "Edit Preventive ME",
    description: "Edit Preventive ME",
    component: EditPreventiveMEPage,
    path: "/preventive-me/:id",
    isEnabled: false,
    access: "Preventive ME",
  },
];
